import routes from '@/common/routes';
import { IClaimDtoClaimStatusEnum } from '@/dtos';
export { ICreateDocumentAggregatorDtoDocumentTypeEnum as DocumentTypesEnum } from '@/dtos';
export enum MyDocumentsTabs {
  RECEIPTS = 'RECEIPTS',
  LMN = 'LMN',
  STATEMENTS = 'STATEMENTS',
  TAX_FORMS = 'TAX_FORMS',
}

export const MyDocumentsTabsTitle = {
  [MyDocumentsTabs.RECEIPTS]: 'Saved Receipts',
  [MyDocumentsTabs.LMN]: 'Letters of Medical Necessity',
  [MyDocumentsTabs.STATEMENTS]: 'Statements',
  [MyDocumentsTabs.TAX_FORMS]: 'Tax Forms',
} as const;

export const MyDocumentsTabsRoutes = {
  [routes.MY_DOCUMENTS_RECEIPTS]: MyDocumentsTabs.RECEIPTS,
  [routes.MY_DOCUMENTS_LMN]: MyDocumentsTabs.LMN,
  [routes.MY_DOCUMENTS_STATEMENTS]: MyDocumentsTabs.STATEMENTS,
  [routes.MY_DOCUMENTS_TAX_FORMS]: MyDocumentsTabs.TAX_FORMS,
} as const;

export interface LMNClaim {
  claimId?: string;
  providerName?: string;
  serviceId?: string;
  statusType?: IClaimDtoClaimStatusEnum;
  approvalStatus?: string;
  requestedAmount?: number;
  serviceOn?: string;
}

// TODO: get from common-fe
export interface LMNClaimDto {
  claim_id?: number;
  provider_name?: string;
  service_id?: number;
  requested_amount?: number;
  service_on?: string;
  approval_status?: string;
  status_type?: IClaimDtoClaimStatusEnum;
}

export interface LettersOfMedicalNecessity {
  id?: string;
  name?: string;
  description?: string;
  validFrom?: string;
  validTo?: string;
  fileUrl?: string;
  documentId?: string;
  employeeId?: string;
  organizationId?: string;
  organizationPath?: string;
  claimIds?: string[];
  claims?: LMNClaim[];
  providerId?: string;
  createdAt?: string;
  thumbnailUrl?: string;
}

export enum LMNPopupMode {
  EDIT = 'EDIT',
  VIEW = 'VIEW',
  UPLOAD = 'UPLOAD',
}

export enum LMNPopupStep {
  DOCUMENT_PREVIEW = 'DOCUMENT_PREVIEW',
  ASSOCIATE_WITH_CLAIMS = 'ASSOCIATE_WITH_CLAIMS',
  CLAIMS_REVIEW_POPUP = 'CLAIMS_REVIEW_POPUP',
}

export interface Receipt {
  id?: string;
  claimId?: string;
  documentId?: string;
  fileUrl?: string;
  fileName?: string;
  providerName?: string;
  createdAt?: string;
}

export const LMN_UPLOAD_STORE_KEY = 'LMN_UPLOAD_STORE_KEY';
